import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { castDraft } from 'immer';

import { ComponentDesignWithInformation } from '@paragon/contract-library';

export interface ComponentDesignWithInformationByAnalysisSetGuidState {
  readonly [analysisSetGuid: string]: ComponentDesignWithInformation | 'loading' | 'error-loading';
}

const initialState: ComponentDesignWithInformationByAnalysisSetGuidState = {};

const componentDesignsWithInformationByAnalysisSetGuidSlice = createSlice({
  name: 'componentDesignsWithInformationByAnalysisSetGuid',
  initialState,
  reducers: {
    componentDesignsWithInformationLoaded: (
      state,
      action: PayloadAction<{ [analysisSetGuid: string]: ComponentDesignWithInformation }>,
    ) => {
      for (const [analysisSetGuid, componentDesignWithInformation] of Object.entries(action.payload)) {
        state[analysisSetGuid] = castDraft(componentDesignWithInformation);
      }
    },
    setLoadingStatus: (
      state,
      action: PayloadAction<{ analysisSetGuids: string[]; status: 'loading' | 'error-loading' }>,
    ) => {
      const { analysisSetGuids, status } = action.payload;
      for (const analysisSetGuid of analysisSetGuids) {
        state[analysisSetGuid] = status;
      }
    },
  },
});

export const { componentDesignsWithInformationLoaded, setLoadingStatus } =
  componentDesignsWithInformationByAnalysisSetGuidSlice.actions;
export const componentDesignsWithInformationByAnalysisSetGuid =
  componentDesignsWithInformationByAnalysisSetGuidSlice.reducer;
